const STORIES_BLOCK_DATA = {
  title: [
    {
      id: 1,
      text: 'default',
      textMob: 'default',
      secondText: 'desktop title',
      secondTextMob: 'mobile title',
      isTextReverse: true,
      isTextReverseMob: true,
      isTextColumn: false,
      isTextColumnMob: true,
      isLeft: true,
      isLeftMob: true,
      isRight: false,
      isRightMob: false,
      color: '#FFFFFF',
      colorMob: '#FFFFFF',
      isTextWithLine: true,
      isTextWithLineMob: true,
      isSecondTextWithLine: false,
      isSecondTextWithLineMob: false,
      firstTextLines: [{
        id: 1,
        isLeftLine: false,
        isRightLine: true,
        isTopLine: false,
        isBottomLine: false,
        color: '#FFFFFF',
        isLineWithSquare: true,
        isLeftLineMob: false,
        isRightLineMob: true,
        isTopLineMob: false,
        isBottomLineMob: false,
        colorMob: '#FFFFFF',
        isLineWithSquareMob: true,
      }],
      secondTextLines: [],
    },
  ],
  description: '',
  descriptionMobile: '',
  dataCards: [
    {
      id: 1,
      title: 'Lorem ipsum dolor sit amet',
      titleMobile: 'Lorem ipsum dolor sit amet',
      imageUrl: '',
      imageUrlMobile: '',
    },
    {
      id: 2,
      title: 'Lorem ipsum dolor sit amet',
      titleMobile: 'Lorem ipsum dolor sit amet',
      imageUrl: '',
      imageUrlMobile: '',
    },
    {
      id: 3,
      title: 'Lorem ipsum dolor sit amet',
      titleMobile: 'Lorem ipsum dolor sit amet',
      imageUrl: '',
      imageUrlMobile: '',
    },
  ],
  buttonText: '',
  buttonTextMobile: '',
  buttonLink: '',
  buttonFunc: () => {},
};

export default STORIES_BLOCK_DATA;
